// Auth
export const REGISTER_CHECK_URL         = 'auth/check'
export const REGISTER_CHECK_ERROR       = 'REGISTER_CHECK_ERROR'
export const REGISTER_CHECK_LOADING     = 'REGISTER_CHECK_LOADING'
export const REGISTER_CHECK_SUCCESS     = 'REGISTER_CHECK_SUCCESS'

export const REGISTER_URL         = 'user/register'
export const REGISTER_ERROR       = 'REGISTER_ERROR'
export const REGISTER_LOADING     = 'REGISTER_LOADING'
export const REGISTER_SUCCESS     = 'REGISTER_SUCCESS'
